

class ShippingProtection extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector("[data-shipping-protection-checkbox]");

    this.checkbox?.addEventListener("change", () => this._toggle());
  }

  get variantId() {
    return this.getAttribute("data-variant-id");
  }

  _toggle() {
    const checked = this.checkbox.checked;

    this.checkbox.disabled = true;

    const revert = () => {
      this.checkbox.checked = !checked;
      this.checkbox.disabled = false;
    };

    if (checked) {
      window.addToCart(
        { id: this.variantId, quantity: 1 },
        {
          onError: revert,
          onAfterAdd: () => {
            this.checkbox.disabled = false;
          },
        },
      );
    } else {
      window.changeCart(
        { id: this.variantId, quantity: 0 },
        {
          onError: revert,
          onAfterAdd: () => {
            this.checkbox.disabled = false;
          },
        },
      );
    }
  }
}

if (!customElements.get("shipping-protection")) {
  customElements.define("shipping-protection", ShippingProtection);
}
